import React from 'react';
import type { CSSProperties, ReactNode } from 'react';

import clsx from 'clsx';

import styles from './Panel.module.css';

interface ChildrenProps {
    children?: ReactNode;
}

export const DiskButtonWrapper = ({ marginLeft, children }: ChildrenProps & { marginLeft?: boolean }) => (
    <div className={clsx(styles.diskButtonWrapper, marginLeft && styles.diskButtonWrapperMarginLeft)}>{children}</div>
);

export const PanelText = ({ multiline, children }: ChildrenProps & { multiline?: boolean }) => (
    <div className={multiline ? undefined : styles.singleLineText}>{children}</div>
);

export const PanelRow = ({
    alignStart,
    alignEnd,
    whiteSpace,
    children,
}: ChildrenProps & { alignStart?: boolean; alignEnd?: boolean; whiteSpace?: CSSProperties['whiteSpace'] }) => (
    <div className={clsx(styles.row, alignEnd && styles.rowAlignEnd, alignStart && styles.rowAlignStart)} style={whiteSpace ? { whiteSpace } : undefined}>
        {children}
    </div>
);

export const PanelFrame = ({ children }: ChildrenProps) => <div className={styles.frame}>{children}</div>;

export const IconWrapper = ({ children }: ChildrenProps) => <span className={styles.iconWrapper}>{children}</span>;

export const DiskBadgeWrapper = ({ children }: ChildrenProps) => <span className={styles.diskBadgeWrapper}>{children}</span>;

export const SelectedDiskBadge = ({ children }: ChildrenProps) => <span className={styles.selectedDiskBadge}>{children}</span>;

export const PanelContent = ({ children }: ChildrenProps) => <div className={styles.content}>{children}</div>;

export const PanelLeftBlock = ({ children }: ChildrenProps) => <div className={styles.leftBlock}>{children}</div>;

export const PanelRightBlock = ({ flex, children }: ChildrenProps & { flex?: boolean }) => (
    <div className={clsx(styles.rightBlock, flex && styles.rightBlockFlex)}>{children}</div>
);

export const CardAccountRow = ({ children }: ChildrenProps) => <span className={styles.cardAccountRow}>{children}</span>;

export const CardAccountSubrow = ({ children }: ChildrenProps) => <span className={styles.cardAccountSubrow}>{children}</span>;
